import ClipboardIcon from '../../../assets/clipboard-list-solid.svg';
import UserIcon from '../../../assets/user-large-solid.svg';
import KeyIcon from '../../../assets/key-solid.svg';
import ConfigIcon from '../../../assets/gear-solid.svg';

export const menuItems = [
  {
    id: 1,
    name: 'Usuarios',
    icon: ClipboardIcon,
    show: true,
    links: [
      {
        name: 'Solicitudes pendientes',
        path: '/admin/user-requests'
      },
      {
        name: 'Aprobados',
        path: '/admin/approved-users'
      },
      {
        name: 'Rechazados',
        path: '/admin/rejected-users'
      }
    ]
  },
  {
    id: 2,
    name: 'Suscriptores',
    icon: ClipboardIcon,
    show: true,
    links: [
      {
        name: 'Últimos suscriptores',
        path: '/admin/last-subscribers'
      }
    ]
  },
  {
    id: 3,
    name: 'Comentarios',
    icon: ClipboardIcon,
    show: true,
    links: [
      {
        name: 'Comentarios pendientes',
        path: '/admin/comments-to-approve'
      }
    ]
  },
  {
    id: 4,
    name: 'Productos',
    icon: ClipboardIcon,
    show: true,
    links: [
      {
        name: 'Lista de productos',
        path: '/admin/product-list'
      }
    ]
  },
  {
    id: 5,
    name: 'Usuarios',
    icon: UserIcon,
    show: true,
    links: [
      {
        name: 'Lista de usuarios',
        path: '/admin/staff-list'
      }
    ]
  },
  {
    id: 7,
    name: 'Configuración de cuenta',
    icon: ConfigIcon,
    show: true,
    links: [
      {
        name: 'Cambiar contraseña',
        path: '/admin/change-password'
      }
    ]
  }
]
